var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.jackpots.length || _vm.winningJackpot)?_c('div',{staticClass:"bng-jackpots-bar"},[_c('div',{staticClass:"jackpots scrollbar"},_vm._l((_vm.jackpots),function(jp){return _c('jackpot',{key:jp.id,attrs:{"jackpot":jp}})}))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/common/jackpots/jackpots-bar/jackpots-bar.vue?vue&type=template&id=264d9815
// module id = 7Xy6
// module chunks = 0